import { Injectable, inject } from '@angular/core';
import { ServiceGridObject } from '@it2go/types';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { selectUrl } from '../../../../../store/global/router.selector';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { setService } from '../../../store/service/service.actions';
import { ServiceService } from '../../../../../services/service.service';

interface State {
    serviceDetail: ServiceGridObject | null,
}

const defaultState: State = {
    serviceDetail: null,
};

@Injectable()
export class ServiceDetailPageStore extends ComponentStoreFactory<State> {

    activeIndex$ = this.globalStore!.select(selectUrl).pipe(
        map((url) => {
            const lookFor = 'services/';
            let root = url.substring(url.indexOf(lookFor) + lookFor.length);
            root = root.substring(root.indexOf('/') + 1);
            let index = root.indexOf('/');
            if (index <= 0) index = root.length;

            return root.substring(0, index);
        }),
    );

    constructor() {
        super(defaultState, inject(Store), inject(ServiceService));
        this.subs.push(
            this.data.serviceDetail$.subscribe((service) => {
                this.globalStore!.dispatch(setService({ service: service?.['items']?.[0] }));
            }),
        );
    }

}
